module.exports = __webpack_public_path__ + "img/SH.5828cc7d.svg";